module.exports = __webpack_public_path__ + "static/media/logo-barreirinhas.55a092e0.png";